import UserDefineArchives from './UserDefineArchives'
export  UserDefineSetting  from './UserDefineSetting'
export default UserDefineArchives



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/user-define-archives/index.jsx